import React, { useMemo } from 'react';
import moment from 'moment';
import classnames from 'classnames';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';

import './styles.scss';

export const RacingResultDetailsTimeFilter = ({ competitionGames = [], routePrefix }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const {
    regionAlias, compId, sportType, matchId,
  } = useParams();

  const timesList = useMemo(() => [
    ...competitionGames?.games?.map((game) => ({
      label: moment.unix(game.start_ts).format('HH:mm'),
      value: game.id,
    })),
  ], [competitionGames]);

  const onChangeGame = (id) => navigate(`${routePrefix}/racings/${sportType}/result/${regionAlias}/${compId}/${id}?${searchParams.toString()}`);

  return (
    <div className="time-filter-container">
      {timesList.map((item) => (
        <div
          key={item.value}
          className={classnames('time-item', {
            active: matchId ? item.value === +matchId : !item.value,
          })}
          onClick={() => onChangeGame(item.value)}
        >
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );
};
